// ============================================
// HERO СЛАЙДЕР (ГЛАВНЫЙ СЛАЙДЕР НА СТРАНИЦЕ)
// ============================================

// Глобальная переменная для хранения текущего фона
let currentHeroBackground = null;
let heroBackgroundElement = null;

// Флаг для отслеживания автоматического переключения слайда (только один раз)
let heroAutoSlideTriggered = false;

// Глобальная функция для установки фона block1
function setBlock1Background(backgroundImage) {
    const block1 = document.querySelector('.block1');
    if (!block1) return;
    
    // Создаем или получаем элемент для фона
    if (!heroBackgroundElement) {
      heroBackgroundElement = document.createElement('div');
      heroBackgroundElement.className = 'hero-background-dynamic';
      block1.insertBefore(heroBackgroundElement, block1.firstChild);
    }
  
  if (backgroundImage) {
    // Сохраняем текущий фон
    currentHeroBackground = backgroundImage;
    
    // Используем путь от корня сайта (как указано в HTML)
    let bgPath = backgroundImage;
    
    // Устанавливаем фон сразу, без задержек
    heroBackgroundElement.style.backgroundImage = `url(${bgPath})`;
    heroBackgroundElement.style.backgroundColor = '';
    heroBackgroundElement.style.opacity = '1';
    
    // Также обновляем медиа-запросы через style элемент для совместимости
    let heroBackgroundStyle = document.getElementById('hero-background-style');
    if (!heroBackgroundStyle) {
      heroBackgroundStyle = document.createElement('style');
      heroBackgroundStyle.id = 'hero-background-style';
      document.head.appendChild(heroBackgroundStyle);
    }
    heroBackgroundStyle.textContent = `
      .hero-background-dynamic {
        background-image: url(${bgPath}) !important;
        background-color: transparent !important;
      }
      @media (max-width: 768px) {
        .hero-background-dynamic {
          background-image: url(${bgPath}) !important;
        }
      }
      @media (min-width: 1440px) {
        .hero-background-dynamic {
          left: 50%;
          margin-left: -50vw;
          background-image: url(${bgPath}) !important;
        }
      }
    `;
    
  } else {
    // Если фона нет, ставим дефолтный цвет #eeeaeb
    currentHeroBackground = null;
    heroBackgroundElement.style.backgroundImage = 'none';
    heroBackgroundElement.style.backgroundColor = '#eeeaeb';
    heroBackgroundElement.style.opacity = '1';
    
    // Обновляем стили
    let heroBackgroundStyle = document.getElementById('hero-background-style');
    if (!heroBackgroundStyle) {
      heroBackgroundStyle = document.createElement('style');
      heroBackgroundStyle.id = 'hero-background-style';
      document.head.appendChild(heroBackgroundStyle);
    }
    heroBackgroundStyle.textContent = `
      .hero-background-dynamic {
        background-image: none !important;
        background-color: #eeeaeb !important;
      }
    `;
    
  }
}

// Функция для восстановления фона, если он был перезаписан
function restoreHeroBackground() {
  if (currentHeroBackground) {
    setBlock1Background(currentHeroBackground);
  }
}

// Функция для установки school_logo2 из пути изображения
let currentSchoolLogo = null;
function setBlock1SchoolLogo(logoImagePath) {
  if (!logoImagePath) return;
  
  // Находим school_logo2 независимо от активного слайда
  // Сначала пытаемся найти в активном слайде, если нет - ищем в любом слайде
  const activeSlide = document.querySelector('.hero-slide.active');
  let schoolLogo2Img = null;
  
  if (activeSlide) {
    schoolLogo2Img = activeSlide.querySelector('.school_logo2 img');
  }
  
  // Если не нашли в активном слайде, ищем в любом слайде
  if (!schoolLogo2Img) {
    schoolLogo2Img = document.querySelector('.school_logo2 img');
  }
  
  if (!schoolLogo2Img) return;
  
  schoolLogo2Img.src = logoImagePath;
  currentSchoolLogo = logoImagePath;
}

// Замена «Early Years Foundation Stage» на «International Private Kindergarten» только в hero-слайдере
function heroSlideTextReplace(text) {
  if (!text || typeof text !== 'string') return text;
  return text.replace(/Early Years Foundation Stage/gi, 'International Private Kindergarten');
}

// Функция для обновления текста слайда
function setBlock1SlideText(slideElement) {
  if (!slideElement) return;
  
  // Находим элементы текста в активном слайде
  const aboutContent = slideElement.querySelector('.about_content');
  if (!aboutContent) return;
  
  const titleElement = aboutContent.querySelector('.promo_text');
  const subtitle = aboutContent.querySelector('.promo_text2');
  
  // Получаем индекс слайда для определения, какой это слайд
  const heroSlides = document.getElementById("heroSlides");
  if (!heroSlides) return;
  const allSlides = heroSlides.querySelectorAll(".hero-slide");
  let slideIndex = -1;
  for (let i = 0; i < allSlides.length; i++) {
    if (allSlides[i] === slideElement) {
      slideIndex = i;
      break;
    }
  }
  
  // Статичный слайд (data-hero-static) и CMS-слайды — текст уже в HTML с сервера, применяем замену
  const isStaticSlide = slideElement.hasAttribute('data-hero-static');
  if (isStaticSlide || slideIndex >= 1) {
    if (titleElement && titleElement.innerHTML) {
      titleElement.dataset.originalText = heroSlideTextReplace(titleElement.innerHTML);
    }
    if (subtitle && subtitle.innerHTML) {
      subtitle.dataset.originalText = heroSlideTextReplace(subtitle.innerHTML);
    }
    return;
  }
}

// Функции updatePromoTextDesktop и updatePromoText2 вынесены в utils/promoText.js

// Обновляем promo_text_desktop и promo_text2 при изменении размера окна
let resizeTimeoutPromoText;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeoutPromoText);
  resizeTimeoutPromoText = setTimeout(() => {
    const allPromoTextDesktop = document.querySelectorAll('.promo_text');
    allPromoTextDesktop.forEach(element => {
      const originalText = element.dataset.originalText;
      if (originalText) {
        if (typeof window.updatePromoTextDesktop === 'function') {
          window.updatePromoTextDesktop(element, originalText);
        }
      }
    });
    
    const allPromoText2 = document.querySelectorAll('.promo_text2');
    allPromoText2.forEach(element => {
      const originalText = element.dataset.originalText;
      if (originalText) {
        if (typeof window.updatePromoText2 === 'function') {
          window.updatePromoText2(element, originalText);
        }
      }
    });
  }, 100);
});

// Замена h2.promo_text на p.promo_text (hero должен быть <p>, не <h2> — SEO/доступность)
function ensurePromoTextIsParagraph() {
  document.querySelectorAll('.hero-slide .promo_text').forEach(function (el) {
    if (el.tagName === 'H2' || el.tagName === 'H3') {
      const p = document.createElement('p');
      p.className = el.className;
      p.dataset.originalText = el.dataset.originalText || '';
      p.textContent = el.textContent.trim();
      if (el.dataset.originalText) p.dataset.originalText = el.dataset.originalText;
      el.parentNode.replaceChild(p, el);
    }
  });
}

// Исправление: hero promo_text должен быть <p>, не <h2> (избегаем дублирования H1/H2 для SEO)
function ensurePromoTextIsP() {
  const heroSlides = document.getElementById("heroSlides");
  if (!heroSlides) return;
  heroSlides.querySelectorAll('.about_content').forEach((about) => {
    const promoH2 = about.querySelector('h2.promo_text, h3.promo_text');
    if (promoH2) {
      const p = document.createElement('p');
      p.className = promoH2.className;
      if (promoH2.dataset.originalText) p.dataset.originalText = promoH2.dataset.originalText;
      p.textContent = promoH2.textContent.trim();
      promoH2.replaceWith(p);
    }
  });
}
window.ensurePromoTextIsP = ensurePromoTextIsP;

function initHeroSlider() {
  ensurePromoTextIsP();
  const heroSlides = document.getElementById("heroSlides");
  const heroPrevBtn = document.getElementById("heroPrev");
  const heroNextBtn = document.getElementById("heroNext");
  const heroPagination = document.getElementById("heroPagination");

  if (heroSlides && heroPrevBtn && heroNextBtn && heroPagination) {
    ensurePromoTextIsParagraph();
    const heroSlideElements = heroSlides.querySelectorAll(".hero-slide");
    let currentHeroSlide = 0;

    // Устанавливаем одинаковую высоту для всех слайдов (по наибольшему)
    function setEqualSlideHeights() {
      if (!heroSlideElements.length) return;

      // Сначала убираем установленные minHeight для правильного измерения
      heroSlideElements.forEach((slide) => {
        slide.style.minHeight = '';
      });
      heroSlides.style.minHeight = '';
      
      let maxHeight = 0;
      // Сначала делаем все слайды видимыми для измерения
      heroSlideElements.forEach((slide) => {
        const originalPosition = slide.style.position;
        const originalOpacity = slide.style.opacity;
        const originalVisibility = slide.style.visibility;
        const originalZIndex = slide.style.zIndex;
        
        slide.style.position = 'relative';
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.zIndex = '1';
        
        const height = slide.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
        
        // Восстанавливаем оригинальные стили
        slide.style.position = originalPosition || '';
        slide.style.opacity = originalOpacity || '';
        slide.style.visibility = originalVisibility || '';
        slide.style.zIndex = originalZIndex || '';
      });
      
      // Применяем максимальную высоту ко всем слайдам
      if (maxHeight > 0) {
        heroSlideElements.forEach((slide) => {
          slide.style.minHeight = maxHeight + 'px';
        });
        heroSlides.style.minHeight = maxHeight + 'px';
      }
    }

    function scheduleEqualSlideHeights() {
      setEqualSlideHeights();
      requestAnimationFrame(setEqualSlideHeights);
      setTimeout(setEqualSlideHeights, 100);
      setTimeout(setEqualSlideHeights, 400);
    }

    // Предзагружаем фоны всех слайдов
    heroSlideElements.forEach((slide) => {
      const bgImage = slide.getAttribute('data-background');
      if (bgImage) {
        const img = new Image();
        img.src = bgImage;
      }
    });

    // Инициализируем фон для первого слайда при загрузке
    if (heroSlideElements.length > 0) {
      const firstSlide = heroSlideElements[0];
      const backgroundImage = firstSlide.getAttribute('data-background');
        setBlock1Background(backgroundImage);
    // Инициализируем school_logo2 для первого слайда
    let schoolLogoImage = firstSlide.getAttribute('data-school-logo');
    
    // Проверяем регион и корректируем изображение для узбекской версии
    try {
      const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') 
        ? window.getCookie(window.COOKIE_NAME) 
        : null;
      if (saved) {
        const regionData = JSON.parse(saved);
        const isUzbekistan = regionData.name === 'Узбекистан' || regionData.name === 'Uzbekistan';
        if (isUzbekistan && schoolLogoImage && schoolLogoImage.includes('school_logo.webp')) {
          schoolLogoImage = landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp');
          firstSlide.setAttribute('data-school-logo', schoolLogoImage);
        }
      }
    } catch (e) {
      // Если не удалось определить регион, используем значение по умолчанию
    }
    
    if (schoolLogoImage) {
      setBlock1SchoolLogo(schoolLogoImage);
    }
      // Инициализируем текст для первого слайда
      setBlock1SlideText(firstSlide);
      // Обновляем promo_text_desktop с учетом ширины экрана
      const titleDesktop = firstSlide.querySelector('.promo_text');
      if (titleDesktop && titleDesktop.dataset.originalText) {
        if (typeof window.updatePromoTextDesktop === 'function') {
          window.updatePromoTextDesktop(titleDesktop, titleDesktop.dataset.originalText);
        }
      }
      // Обновляем promo_text2 с учетом ширины экрана
      const subtitle = firstSlide.querySelector('.promo_text2');
      if (subtitle && subtitle.dataset.originalText) {
        if (typeof window.updatePromoText2 === 'function') {
          window.updatePromoText2(subtitle, subtitle.dataset.originalText);
        }
      }
    }

    // Устанавливаем одинаковую высоту после загрузки контента
    scheduleEqualSlideHeights();
    
    // Обновляем высоту при изменении размера окна
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        scheduleEqualSlideHeights();
      }, 200);
    });

    heroSlideElements.forEach((slide) => {
      slide.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', scheduleEqualSlideHeights, { once: true });
      });
    });

  // Создаем буллеты пагинации
  heroSlideElements.forEach((_, index) => {
    const bullet = document.createElement("span");
    bullet.className = "hero-pagination-bullet" + (index === 0 ? " active" : "");
    bullet.addEventListener("click", () => goToHeroSlide(index));
    heroPagination.appendChild(bullet);
  });

  function updateHeroSlider() {
    heroSlideElements.forEach((slide, index) => {
      if (index === currentHeroSlide) {
        slide.classList.add("active");
      } else {
        slide.classList.remove("active");
      }
    });

    // Обновляем буллеты
    const bullets = heroPagination.querySelectorAll(".hero-pagination-bullet");
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle("active", index === currentHeroSlide);
    });

    // Обновляем фон block1 в зависимости от активного слайда
    const activeSlide = heroSlideElements[currentHeroSlide];
    if (activeSlide) {
      const backgroundImage = activeSlide.getAttribute('data-background');
        setBlock1Background(backgroundImage);
      // Обновляем school_logo2 из атрибута слайда
      let schoolLogoImage = activeSlide.getAttribute('data-school-logo');
      
      // Если это первый слайд, проверяем регион для узбекской версии
      if (currentHeroSlide === 0) {
        try {
          const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') 
            ? window.getCookie(window.COOKIE_NAME) 
            : null;
          if (saved) {
            const regionData = JSON.parse(saved);
            const isUzbekistan = regionData.name === 'Узбекистан' || regionData.name === 'Uzbekistan';
            if (isUzbekistan && schoolLogoImage && schoolLogoImage.includes('school_logo.webp')) {
              schoolLogoImage = landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp');
              activeSlide.setAttribute('data-school-logo', schoolLogoImage);
            }
          }
        } catch (e) {
          // Если не удалось определить регион, используем значение по умолчанию
        }
      }
      
      if (schoolLogoImage) {
        setBlock1SchoolLogo(schoolLogoImage);
      }
      // Обновляем текст слайда
      setBlock1SlideText(activeSlide);
      // Обновляем promo_text_desktop с учетом ширины экрана
      const activeTitleDesktop = activeSlide.querySelector('.promo_text');
      if (activeTitleDesktop && activeTitleDesktop.dataset.originalText) {
        if (typeof window.updatePromoTextDesktop === 'function') {
          window.updatePromoTextDesktop(activeTitleDesktop, activeTitleDesktop.dataset.originalText);
        }
      }
      // Обновляем promo_text2 с учетом ширины экрана
      const activeSubtitle = activeSlide.querySelector('.promo_text2');
      if (activeSubtitle && activeSubtitle.dataset.originalText) {
        if (typeof window.updatePromoText2 === 'function') {
          window.updatePromoText2(activeSubtitle, activeSubtitle.dataset.originalText);
        }
      }
    }

    if (window.innerWidth <= 768) {
      scheduleEqualSlideHeights();
    }
  }

  function goToHeroSlide(index) {
    currentHeroSlide = index;
    updateHeroSlider();
  }

  // Автоматическое переключение с первого на второй слайд через 2 секунды после загрузки (только один раз)
  if (heroSlideElements.length >= 2 && currentHeroSlide === 0 && !heroAutoSlideTriggered) {
    setTimeout(() => {
      if (!heroAutoSlideTriggered) {
        heroAutoSlideTriggered = true;
        goToHeroSlide(1); // Переключаем на второй слайд (индекс 1)
      }
    }, 2000); // 2 секунды
  }

  function nextHeroSlide() {
    currentHeroSlide = (currentHeroSlide + 1) % heroSlideElements.length;
    updateHeroSlider();
  }

  function prevHeroSlide() {
    currentHeroSlide = (currentHeroSlide - 1 + heroSlideElements.length) % heroSlideElements.length;
    updateHeroSlider();
  }

  heroPrevBtn.addEventListener("click", prevHeroSlide);
  heroNextBtn.addEventListener("click", nextHeroSlide);

  // Автопрокрутка hero слайдера (опционально)
  // setInterval(nextHeroSlide, 5000);

  // Добавляем функционал свайпа для hero-slides при 768px
  let isHeroDragging = false;
  let heroStartX = 0;
  let heroStartY = 0;
  let heroCurrentX = 0;
  let heroTouchStartX = 0;
  let heroTouchStartY = 0;
  let heroTouchCurrentX = 0;

  // Обработчики для свайпа мышью
  heroSlides.addEventListener("mousedown", (e) => {
    if (window.innerWidth > 768) return; // Только на мобильных
    isHeroDragging = true;
    heroStartX = e.clientX;
    heroStartY = e.clientY;
    heroSlides.style.cursor = "grabbing";
    e.preventDefault();
  });

  heroSlides.addEventListener("mousemove", (e) => {
    if (!isHeroDragging || window.innerWidth > 768) return;
    heroCurrentX = e.clientX - heroStartX;
  });

  heroSlides.addEventListener("mouseup", () => {
    if (!isHeroDragging || window.innerWidth > 768) return;
    isHeroDragging = false;
    heroSlides.style.cursor = "grab";
    
    const threshold = 50; // Минимальное расстояние для смены слайда
    if (Math.abs(heroCurrentX) > threshold) {
      if (heroCurrentX > 0) {
        prevHeroSlide();
      } else {
        nextHeroSlide();
      }
    }
    heroCurrentX = 0;
  });

  heroSlides.addEventListener("mouseleave", () => {
    if (isHeroDragging) {
      isHeroDragging = false;
      heroSlides.style.cursor = "grab";
      heroCurrentX = 0;
    }
  });

  // Обработчики для touch событий (свайп на мобильных)
  heroSlides.addEventListener("touchstart", (e) => {
    if (window.innerWidth > 768) return;
    isHeroDragging = true;
    heroTouchStartX = e.touches[0].clientX;
    heroTouchStartY = e.touches[0].clientY;
    // НЕ вызываем preventDefault здесь, чтобы не блокировать вертикальный скроллинг
  });

  heroSlides.addEventListener("touchmove", (e) => {
    if (!isHeroDragging || window.innerWidth > 768) return;
    heroTouchCurrentX = e.touches[0].clientX - heroTouchStartX;
    const touchCurrentY = e.touches[0].clientY - heroTouchStartY;
    
    // Проверяем, что это горизонтальный свайп, а не вертикальный
    // Только при горизонтальном свайпе блокируем дефолтное поведение
    if (Math.abs(heroTouchCurrentX) > Math.abs(touchCurrentY) && Math.abs(heroTouchCurrentX) > 10) {
      e.preventDefault();
    }
  });

  heroSlides.addEventListener("touchend", () => {
    if (!isHeroDragging || window.innerWidth > 768) return;
    isHeroDragging = false;
    
    const threshold = 50; // Минимальное расстояние для смены слайда
    if (Math.abs(heroTouchCurrentX) > threshold) {
      if (heroTouchCurrentX > 0) {
        prevHeroSlide();
      } else {
        nextHeroSlide();
      }
    }
    heroTouchCurrentX = 0;
  });
  }
}

// Инициализируем hero slider при загрузке DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initHeroSlider();
    // Дополнительно устанавливаем фон после небольшой задержки для надежности
    setTimeout(() => {
      const heroSlides = document.getElementById("heroSlides");
      if (heroSlides) {
        const firstSlide = heroSlides.querySelector(".hero-slide.active, .hero-slide");
        if (firstSlide) {
          const backgroundImage = firstSlide.getAttribute('data-background');
            setBlock1Background(backgroundImage);
          let schoolLogoImage = firstSlide.getAttribute('data-school-logo');
          
          // Проверяем регион и корректируем изображение для узбекской версии
          try {
            const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') 
              ? window.getCookie(window.COOKIE_NAME) 
              : null;
            if (saved) {
              const regionData = JSON.parse(saved);
              const isUzbekistan = regionData.name === 'Узбекистан' || regionData.name === 'Uzbekistan';
              if (isUzbekistan && schoolLogoImage && schoolLogoImage.includes('school_logo.webp')) {
                schoolLogoImage = landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp');
                firstSlide.setAttribute('data-school-logo', schoolLogoImage);
              }
            }
          } catch (e) {
            // Если не удалось определить регион, используем значение по умолчанию
          }
          
          if (schoolLogoImage) {
            setBlock1SchoolLogo(schoolLogoImage);
          }
          setBlock1SlideText(firstSlide);
        }
      }
    }, 100);
    
    // Периодически проверяем и восстанавливаем фон (на случай если что-то его перезаписывает)
    setInterval(() => {
      restoreHeroBackground();
    }, 500);
  });
} else {
  initHeroSlider();
  // Дополнительно устанавливаем фон после небольшой задержки для надежности
  setTimeout(() => {
    const heroSlides = document.getElementById("heroSlides");
    if (heroSlides) {
      const firstSlide = heroSlides.querySelector(".hero-slide.active, .hero-slide");
      if (firstSlide) {
        const backgroundImage = firstSlide.getAttribute('data-background');
          setBlock1Background(backgroundImage);
        let schoolLogoImage = firstSlide.getAttribute('data-school-logo');
        
        // Проверяем регион и корректируем изображение для узбекской версии
        try {
          const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') 
            ? window.getCookie(window.COOKIE_NAME) 
            : null;
          if (saved) {
            const regionData = JSON.parse(saved);
            const isUzbekistan = regionData.name === 'Узбекистан' || regionData.name === 'Uzbekistan';
            if (isUzbekistan && schoolLogoImage && schoolLogoImage.includes('school_logo.webp')) {
              schoolLogoImage = landingAssetPath('/landing_2025/src/img/All/Slide-1_uzb.webp');
              firstSlide.setAttribute('data-school-logo', schoolLogoImage);
            }
          }
        } catch (e) {
          // Если не удалось определить регион, используем значение по умолчанию
        }
        
        if (schoolLogoImage) {
          setBlock1SchoolLogo(schoolLogoImage);
        }
        setBlock1SlideText(firstSlide);
      }
    }
  }, 100);
  
  // Периодически проверяем и восстанавливаем фон (на случай если что-то его перезаписывает)
  setInterval(() => {
    restoreHeroBackground();
  }, 500);
}

// Экспортируем функции глобально
window.initHeroSlider = initHeroSlider;
window.setBlock1Background = setBlock1Background;
window.restoreHeroBackground = restoreHeroBackground;
window.setBlock1SchoolLogo = setBlock1SchoolLogo;
window.setBlock1SlideText = setBlock1SlideText;
